import FormComponent from '../../../generic/form';

export default class Form extends FormComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        super.init();
    }
};
